import { FinancialStatementForm } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';

export const RECEIVABLES_TABLE_ARIA_LABEL = 'Дебіторська заборгованість';
export const RECEIVABLES_SECTION_TITLES: Record<FinancialStatementForm, string> = {
  [FinancialStatementForm.Large]: '10. Розшифровка рядків Форми №1',
  [FinancialStatementForm.SmallOrSimplified]:
    '10. Розшифровка рядків Форми №1-м / Форми №1-мс',
};
export const RECEIVABLES_TABLE_MIN_WIDTH = 1460;
export const RECEIVABLES_DATE_COLUMN_INDEXES = [5, 6] as const;
export const RECEIVABLES_TABLE_HEADERS = [
  'Найменування контрагента',
  'ЄДРПОУ',
  'Предмет заборгованості',
  'Загальна заборгованість, тис. од.',
  'Прострочена заборгованість, тис. од.',
  'Дата виникнення',
  'Дата погашення',
  'Рядок фінансової звітності',
] as const;
export const RECEIVABLES_TABLE_COLUMN_WIDTHS = [
  '20%',
  '9%',
  '19%',
  '13%',
  '13%',
  '9%',
  '9%',
  '8%',
] as const;
